// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { mergeClasses } from 'util/commons';
import styles from './CheckboxField.module.scss';

type CheckboxFieldProps = {
  input?: React.InputHTMLAttributes<HTMLInputElement>;
  title?: React.ReactNode;
  size?: 'medium' | 'large';
  checkedStyle?: 'partial' | 'checked';
};

const CheckboxField = (props: CheckboxFieldProps) => {
  return (
    <label
      className={mergeClasses(styles.checkbox, {
        [styles.large]: props.size === 'large',
        [styles.partial]: props.checkedStyle === 'partial',
      })}
    >
      <input {...props?.input} type="checkbox" />
      <span className={styles.checkmark}></span>
      {props.title && <span className={styles.text}>{props.title}</span>}
    </label>
  );
};

export default CheckboxField;
